import request from "axios"
import qs from "qs"
import crypto from 'crypto-js';
const {MD5} = crypto;
let time=new Date().getTime()
const instance = request.create({
    baseURL: "https://api.artron.net",
    // baseURL: "https://yapi.artron.net/mock/89",
    // baseURL: "https://api.artron.net",
    // baseURL: "https://tulu-app.artron.net",

    timeout: 1000 * 10,
    withCredentials: true
})
const instanceSSR = request.create({
    baseURL: "https://api.artron.net",
    // baseURL: "https://yapi.artron.net/mock/89",
    // baseURL: "https://api.artron.net",
    // baseURL: "https://tulu-app.artron.net",
    headers: {
        'Time': time,
        'Api-Token': MD5(time+'tulu2035fdkg20dlfdl24r!!').toString(),
        // "X-Requested-With": "XMLHttpRequest",
    },
    timeout: 1000 * 10,
    withCredentials: true
})

const tuluService = request.create({
    // baseURL: "https://api.artron.net/",
    baseURL: "https://tulu-app.artron.net/",
    // baseURL: "https://tulu-app.artron.net/",
    timeout: 1000 * 10,
    withCredentials: true,
});
const advService = request.create({
    // baseURL: "https://api.artron.net/",
    baseURL: "https://show.artron.net",
    // baseURL: "https://tulu-app.artron.net/",
    timeout: 1000 * 10,
    withCredentials: true,
});
const decryptCBC=(word, keyStr, ivStr) => {
    word = (word + '').replace(/\n*$/g, '').replace(/\n/g, ''); //增加这一行，将换行符替换为空
    keyStr = keyStr ? keyStr : "abcdefgabcdefg12";
    ivStr = ivStr ? ivStr : "!@#$%asdfg12345";
    let key = crypto.enc.Utf8.parse(keyStr);
    let iv = crypto.enc.Utf8.parse(ivStr);
    let decrypt = crypto.AES.decrypt(word, key, {
        iv,
        mode: crypto.mode.CBC,
        padding: crypto.pad.ZeroPadding
    })
    return decrypt.toString(crypto.enc.Utf8)
}
// export const get = (url, params) => insstance.get(url, { params })
export const get = (url, params) => {
    try{
        return Promise.race([
            new Promise((resolve, reject) => {
                // let data = qs.stringify(
                //     param
                // );
                // axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
                request.defaults.headers.get['IsWap'] = 2;
                instance.get( url,  {params:params})
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    })
            }),
            // new Promise((resolve, reject)=>{setTimeout(()=>{reject('服务器超时！')}, 50000);})
        ])
            .then((result) => {
                if(result.hasOwnProperty("data") && typeof(result)=='object')
                    return Promise.resolve(result.data);
                else
                    return Promise.reject.data;
            })
            .catch(error=>{
                // return Promise.reject.data;
                throw new Error('url>>'+url+error.toString());
            });
    }catch (e) {
        return false;
    }
}
export const post = (url, params, config) => {
    if (config) {
        try{
            return Promise.race([
                new Promise((resolve, reject) => {
                    // let data = qs.stringify(
                    //     param
                    // );
                    // axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
                    request.defaults.headers.post['IsWap'] = 2;
                    instance.post( url,  params, config)
                        .then(response => {
                            resolve(response);
                        })
                        .catch(error => {
                            reject(error);
                        })
                }),
                // new Promise((resolve, reject)=>{setTimeout(()=>{reject('服务器超时！')}, 50000);})
            ])
                .then((result) => {
                    if(result.hasOwnProperty("data") && typeof(result)=='object')
                        return Promise.resolve(result.data);
                    else
                        return Promise.reject.data;
                })
                .catch(error=>{
                    // return Promise.reject.data;
                    throw new Error('url>>'+url+error.toString());
                });
        }catch (e) {
            return false;
        }
        // return instance.post(url, params, config)
    } else {
        try{
            return Promise.race([
                new Promise((resolve, reject) => {
                    // let data = qs.stringify(
                    //     param
                    // );
                    // axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
                    request.defaults.headers.post['IsWap'] = 2;
                    instance.post( url, qs.stringify(params))
                        .then(response => {
                            resolve(response);
                        })
                        .catch(error => {
                            reject(error);
                        })
                }),
                // new Promise((resolve, reject)=>{setTimeout(()=>{reject('服务器超时！')}, 50000);})
            ])
            .then((result) => {
                if(result.hasOwnProperty("data") && typeof(result)=='object')
                    return Promise.resolve(result.data);
                else
                    return Promise.reject.data;
            })
            .catch(error=>{
                // return Promise.reject.data;
                throw new Error('url>>'+url+error.toString());
            });
        }catch (e) {
            return false;
        }
    }
}

//加密请求
export const postAES = (url, params, config) => {
    try{
        return Promise.race([
            new Promise((resolve, reject) => {
               let date = new Date();
               let timestampInSeconds = Math.floor(date.getTime() / 1000);
               
                request.defaults.headers.post['IsWap'] = 1;


                instance.post( 'https://api.artron.net/v1/sequence',  { appType: 2,timestamp: timestampInSeconds}, config ? config : undefined)
                    .then(response => {
                       if(response.data.code==0){
                           let mountainskeyStr=decryptCBC(response.data.data.content,'tulu2_'+timestampInSeconds,'tulu2_'+timestampInSeconds)
                           let mountainskey=mountainskeyStr.slice(200).split("").slice(0, 16).join("");
                           instance.post( url,  params,  config ? config : undefined)
                           .then(res => {
                               // console.log(res)
                               //去除尾部乱码
                               if(res.data.code==0){
                               let detailkeyStr=decryptCBC(res.data.data.content,mountainskey,mountainskey).split("");
                               let i = detailkeyStr.length - 1;
                               while (i >= 0) {
                                   if(detailkeyStr[i]!=='}'){
                                       detailkeyStr.pop()
                                       i--;
                                   }else{
                                       break;
                                   }
                                  
                               }
                                       detailkeyStr=detailkeyStr.join('');
                                       res.data.data=JSON.parse(detailkeyStr)
                                       resolve(res);
                               }else if(res.data.code==-9006){
                                        reject(res.data.message);
                                        alert(res.data.message);
                                        setTimeout(()=>{
                                            window.location.href='https://auction.artron.net/';
                                        }, 1000);
                                }
                               // console.log(JSON.parse(detailkeyStr))
                               // resolve(response);
                           })
                           .catch(error => {
                               reject(error);
                           })


                       }else{
                           reject('服务器繁忙，请稍后再试！');
                       }
                       //  resolve(response);
                        // token = response.headers['sso-tulu-token']
                    })
                    .catch(error => {
                        reject(error);
                    })
            }),
        ])
            .then((result) => {
                if(result.hasOwnProperty("data") && typeof(result)=='object')
                    return Promise.resolve(result.data);
                else
                    return Promise.reject.data;
            })
            .catch(error=>{
                throw new Error('url>>'+error.toString());
            });
    }catch (e) {
        return false;
    }
}
export const postSSR = (url, params, config) => {
    try{
        return Promise.race([
            new Promise((resolve, reject) => {
               let date = new Date();
               let timestampInSeconds = Math.floor(date.getTime() / 1000);
                request.defaults.headers.post['IsWap'] = 2;
                instance.post( 'https://api.artron.net/v1/sequence',  { appType: 2,timestamp: timestampInSeconds}, config ? config : undefined)
                    .then(response => {
                       if(response.data.code==0){
                      
                           let mountainskeyStr=decryptCBC(response.data.data.content,'tulu2_'+timestampInSeconds,'tulu2_'+timestampInSeconds)
                           let mountainskey=mountainskeyStr.slice(200).split("").slice(0, 16).join("");
                           try{   
                           instanceSSR.post( url,  params,  config ? config : undefined)
                           .then(res => {
                               //去除尾部乱码
                               if(res.data.code==0){
                               let detailkeyStr=decryptCBC(res.data.data.content,mountainskey,mountainskey).split("");
                               let i = detailkeyStr.length - 1;
                               while (i >= 0) {
                                   if(detailkeyStr[i]!=='}'){
                                       detailkeyStr.pop()
                                       i--;
                                   }else{
                                       break;
                                   }
                                  
                               }
                                       detailkeyStr=detailkeyStr.join('');
                                       res.data.data=JSON.parse(detailkeyStr)
                                       resolve(res);
                               }else if(res.data.code==-9006){
                                    reject(res.data.message);
                                    alert(res.data.message);
                                    setTimeout(()=>{
                                       window.location.href='https://auction.artron.net/';
                                    }, 1000);
                               }
                               // console.log(JSON.parse(detailkeyStr))
                               // resolve(response);
                           })
                           .catch(error => {
                               reject(error);
                           })
                            }catch (e) {
                                reject(e);
                            }


                       }else{
                           reject('服务器繁忙，请稍后再试！');
                       }
                       //  resolve(response);
                        // token = response.headers['sso-tulu-token']
                    })
                    .catch(error => {
                        reject(error);
                    })
            }),
        ])
            .then((result) => {
                if(result.hasOwnProperty("data") && typeof(result)=='object')
                    return Promise.resolve(result.data);
                else
                    return Promise.reject.data;
            })
            .catch(error=>{
                throw new Error('url>>'+error.toString());
            });
    }catch (e) {
        return false;
    }
}
export const put = (url, params) => instance.put(url, qs.stringify(params))
export const del = (url, params) => instance.delete(url, { params })
export const tuluPost = (url, params, config) => {
    if (config) {
        try{
            return Promise.race([
                new Promise((resolve, reject) => {
                    // let data = qs.stringify(
                    //     param
                    // );
                    // request.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
                    request.defaults.headers.post['IsWap'] = 1;
                    /* request.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
                    request.defaults.headers.post['Access-Control-Allow-Methods'] = 'GET, POST, OPTIONS, PUT, DELETE';
                    request.defaults.headers.post['Access-Control-Allow-Headers'] = 'Content-Type'; */
                    tuluService.post( url,  params, config)
                        .then(response => {
                            resolve(response);
                        })
                        .catch(error => {
                            reject(error);
                        })
                }),
                // new Promise((resolve, reject)=>{setTimeout(()=>{reject('服务器超时！')}, 50000);})
            ])
                .then((result) => {
                    if(result.hasOwnProperty("data") && typeof(result)=='object')
                        return Promise.resolve(result.data);
                    else
                        return Promise.reject.data;
                })
                .catch(error=>{
                    // return Promise.reject.data;
                    throw new Error('url>>'+error.toString());
                });
        }catch (e) {
            return false;
        }
        // return instance.post(url, params, config)
    } else {
        try{
            return Promise.race([
                new Promise((resolve, reject) => {
                    // let data = qs.stringify(
                    //     param
                    // );
                    // request.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
                    request.defaults.headers.post['IsWap'] = 1;
                    /* request.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
                    request.defaults.headers.post['Access-Control-Allow-Methods'] = 'GET, POST, OPTIONS, PUT, DELETE';
                    request.defaults.headers.post['Access-Control-Allow-Headers'] = 'Content-Type'; */
                    tuluService.post( url, qs.stringify(params))
                        .then(response => {
                            resolve(response);
                        })
                        .catch(error => {
                            reject(error);
                        })
                }),
                // new Promise((resolve, reject)=>{setTimeout(()=>{reject('服务器超时！')}, 50000);})
            ])
                .then((result) => {
                    if(result.hasOwnProperty("data") && typeof(result)=='object')
                        return Promise.resolve(result.data);
                    else
                        return Promise.reject.data;
                })
                .catch(error=>{
                    // return Promise.reject.data;
                    throw new Error('url>>'+url+">>"+error.toString());
                });
        }catch (e) {
            return false;
        }
    }
}

export const getAdv = (url,params) => advService.get(url, { params })
